<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaUnidades"
      option-label="nome"
      option-value="id"
      behavior="menu"
      label-color="grey-6"
      label="Selecione a unidade."
      input-debounce="300"
      :multiple="props.multiple"
      map-options
      use-input
      hide-bottom-space
      :rules="validacao ? [(val) => val || 'Campo Obrigatório'] : []"
      @filter="filtrar"
      :display-value="
        modelValue?.nome?.length > 9
          ? `${modelValue?.nome.substring(0, 9)}....`
          : modelValue?.nome
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="props?.modelValue?.nome">
        {{ props?.modelValue?.nome }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
  multiple: {
    type: Boolean,
    default: false,
  },
  validacao: {
    type: Boolean,
    default: false,
  },
  todas: {
    type: Boolean,
    default: false,
  },
});

const listaUnidades = ref([]);

const listarUnidades = async (val) => {
  try {
    const response = await store.dispatch("org/listarUnidades", {});
    listaUnidades.value = response.listaUnidades;

    if (props.todas) {
      listaUnidades.value.unshift({
        nome: "Todas",
        id: "",
      });
    }

    const needle = val.toLowerCase();
    listaUnidades.value = listaUnidades.value.filter(
      (v) => v.nome.toLowerCase().indexOf(needle) > -1
    );
  } catch (error) {
    console.error(error);
  }
};

const filtrar = async (val, update) => {
  await listarUnidades(val);
  setTimeout(() => {
    update();
  }, 500);
};
</script>
